import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import { formatPhone } from '@/lib/utils/formatters'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, formatDate, applicantLink } from '../../utils/configuredReportFormatters'

export const feeNotPaidColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) => display(row.property_name),
  },
  {
    id: 'applicant_id',
    label: 'Applicant ID',
    sortKey: 'applicant_id',
    render: (row) => applicantLink(row.applicant_id),
  },
  {
    id: 'applicant_name',
    label: 'Applicant Name',
    sortKey: 'applicant_name',
    render: (row) => display(row.applicant_name ?? row.name),
  },
  {
    id: 'email',
    label: 'Email',
    sortKey: 'email',
    render: (row) => display(row.email),
  },
  {
    id: 'mobile',
    label: 'Phone Number',
    sortKey: 'mobile_no',
    render: (row) =>
      formatPhone(String(row.mobile ?? row.mobile_no ?? '')) || '—',
  },
  {
    id: 'application_created_date',
    label: 'Application Created Date',
    sortKey: 'application_created_date',
    render: (row) => formatDate(row.application_created_date ?? row.created_at),
  },
  {
    id: 'application_last_updated',
    label: 'Application Last Updated',
    sortKey: 'application_last_updated',
    render: (row) => formatDate(row.application_last_updated ?? row.updated_at),
  },
]
